import type { GameEvent } from "@/types"

export const victoriaEvents: Record<string, GameEvent> = {
    "dlg-vc-brigid": {
        id: "dlg-vc-brigid",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.brigid",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcBrigid.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.vcBrigid.d2",
            },
            {
                speaker: "map.speaker.brigid",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcBrigid.d3",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.vcBrigid.d4",
            },
            {
                speaker: "map.speaker.brigid",
                expression: "confused",
                side: "left",
                text: "map.dialog.vcBrigid.d5",
            },
            {
                speaker: "map.speaker.brigid",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcBrigid.d6",
            },
            {
                speaker: "map.speaker.brigid",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcBrigid.d7",
            },
            {
                speaker: "map.speaker.savage",
                expression: "happy",
                side: "right",
                text: "map.dialog.vcBrigid.d8",
            },
        ],
        choices: [],
    },

    "dlg-vc-heidi": {
        id: "dlg-vc-heidi",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.amiya",
                expression: "happy",
                side: "left",
                text: "map.dialog.vcHeidi.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "rconfused",
                side: "right",
                text: "map.dialog.vcHeidi.d2",
            },
            {
                speaker: "map.speaker.heidi",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcHeidi.d3",
            },
            {
                speaker: "map.speaker.heidi",
                expression: "normal",
                side: "left",
                text: "map.dialog.vcHeidi.d4",
            },
            {
                speaker: "map.speaker.heidi",
                expression: "happy",
                side: "left",
                text: "map.dialog.vcHeidi.d5",
            },
            {
                speaker: "map.speaker.heidi",
                expression: "happy",
                side: "left",
                text: "map.dialog.vcHeidi.d6",
            },
        ],
        choices: [],
    },

    "evt-vc-01": {
        id: "evt-vc-01",
        type: "event",
        description: "map.event.vc01.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.vc01.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "happy",
                        text: "map.event.vc01.c1d",
                    },
                ],
            },
        ],
    },

    "evt-vc-02": {
        id: "evt-vc-02",
        type: "event",
        description: "map.event.vc02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.vc02.c1",
                resultText: "map.event.vc02.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.vc02.c1d",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.vc02.c2",
                resultText: "map.event.vc02.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "happy",
                        text: "map.event.vc02.c2d",
                    },
                ],
            },
        ],
    },

    "evt-vc-03": {
        id: "evt-vc-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-3.png"),
        description: "map.event.vc03.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.vc03.c1",
                resultText: "map.event.vc03.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.brigid",
                        expression: "normal",
                        text: "map.event.vc03.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.vc03.c2",
                resultText: "map.event.vc03.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.brigid",
                        expression: "normal",
                        text: "map.event.vc03.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-vc-01",
    },

    "evt-vc-04": {
        id: "evt-vc-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-4.png"),
        description: "map.event.vc04.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.vc04.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.vc04.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-vc-02",
    },

    "evt-vc-05": {
        id: "evt-vc-05",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-victoria-5.png"),
        description: "map.event.vc05.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.vc05.c1",
                resultText: "map.event.vc05.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.heidi",
                        expression: "happy",
                        text: "map.event.vc05.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.vc05.c2",
                resultText: "map.event.vc05.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.heidi",
                        expression: "happy",
                        text: "map.event.vc05.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-vc-03",
    },
}
